export default "__VITE_ASSET__BcJ3eyJU__"